module.exports = __webpack_public_path__ + "img/speaker-2.492c4002.jpg";